import { Animate } from "components/lib";
import "./styles.module.scss";

export function Help(props) {
  return <Animate type="pop"></Animate>;
}
